<template>
    <transition name="modal">
        <div class="modal-mask quote-send-modal-mask">
            <div class="modal-wrapper">
                <div class="options modal-container">
                    <div class="modal-header">
                        <i class="close icon" v-on:click="$emit('close')"></i>
                        <h3>{{ title }}</h3>
                    </div>

                    <div class="ui divider"></div>

                    <div class="modal-body scrolling content">
                        <form class="ui form">

                            <div class="fields">
                                <div class="eight wide field">
                                    <div class="ui fluid basic button" @click="$emit('email')">
                                        <i class="envelope large icon"></i>
                                        <strong>Send via Email</strong></div>
                                </div>

                                <div class="eight wide field">
                                    <div class="ui fluid basic button" @click="$emit('download')">
                                        <i class="download large icon"></i>
                                        <strong>Download</strong></div>
                                </div>
                            </div>

                        </form>
                    </div>

                    <div class="modal-footer">
                        <div class="ui basic button smardie-btn-secondary" @click="$emit('cancel')">Cancel</div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "QuoteSendOptionModal",
    props: {
        title: { type: String, default: 'Send Quote' }
    }
}
</script>